import { useEffect, useState } from 'react'

import XIcon from '@heroicons/react/outline/XIcon'

import {
  CustomFieldType,
  MemberListFilterByOperator,
} from '@tribeplatform/gql-client/types'
import { Form } from '@tribeplatform/react-sdk/components'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { FieldInput } from '../CustomField/FieldInput'
import { FieldOperatorPicker } from '../CustomField/FieldOperatorPicker'
import { FieldPicker } from '../CustomField/FieldPicker'

export const getDefaultOperator = field => {
  const defaultOperator = {
    [CustomFieldType.DATE]: MemberListFilterByOperator.GTE,
  }
  return defaultOperator[field?.type] || MemberListFilterByOperator.EQUALS
}

export const FieldsFilter = ({ fields, setFilters }) => {
  const filterFields = [...fields.filter(field => field.type)]

  const [filterBy, setFilterBy] = useState([])

  useEffect(() => {
    const newFilterBy = []
    filterBy.forEach(filter => {
      if (typeof filter?.value === 'undefined' || filter?.value === '') return
      newFilterBy.push({
        ...filter,
        ...{
          value: JSON.stringify(filter.value),
          key: filter?.key?.replace('mappedFields.', 'fields.'),
        },
      })
    })
    setFilters(newFilterBy)
  }, [filterBy])

  if (!filterFields.length) return null

  return (
    <Form onSubmit={null}>
      <div className="flex flex-wrap items-center">
        {filterBy.map((filter, index) => {
          return (
            <div key={filter.key} className="flex items-center">
              <div className="flex space-x-3 items-center bg-surface-50 mb-3 mr-3 p-3 rounded-md shadow">
                <div className="flex-shrink-0">
                  <FieldPicker
                    fields={filterFields}
                    value={filter?.key}
                    onChange={key => {
                      const newFilterBy = [...filterBy]
                      newFilterBy[index] = {
                        ...newFilterBy[index],
                        ...{ key },
                      }
                      setFilterBy(newFilterBy)
                    }}
                  />
                </div>
                {filter?.key ? (
                  <FieldOperatorPicker
                    value={filter?.operator}
                    onChange={operator => {
                      const newFilterBy = [...filterBy]
                      newFilterBy[index] = {
                        ...newFilterBy[index],
                        ...{ operator },
                      }
                      setFilterBy(newFilterBy)
                    }}
                    field={filterFields?.find(
                      field => field.accessor === filter.key,
                    )}
                  />
                ) : null}
                {filter?.key && filter?.operator ? (
                  <FieldInput
                    onChange={value => {
                      const newFilterBy = [...filterBy]
                      newFilterBy[index] = {
                        ...newFilterBy[index],
                        ...{ value },
                      }
                      setFilterBy(newFilterBy)
                    }}
                    value={filter?.value}
                    field={filterFields?.find(
                      field => field.accessor === filter.key,
                    )}
                  />
                ) : null}
                <Button
                  size="xs"
                  variant="basic"
                  rounded
                  leadingIcon={<XIcon />}
                  onClick={() => {
                    const newFilter = [...filterBy]
                    newFilter.splice(index, 1)
                    setFilterBy(newFilter)
                  }}
                ></Button>
              </div>
              {index !== filterBy.length - 1 && (
                <div className="mb-3 mr-3">and</div>
              )}
            </div>
          )
        })}
        <div className="mb-3 flex-shrink-0">
          <FieldPicker
            fields={filterFields}
            value={null}
            onChange={key => {
              const newFilterBy = [
                ...filterBy,
                {
                  key,
                  operator: getDefaultOperator(
                    fields?.find(field => field.accessor === key),
                  ),
                  value: undefined,
                },
              ]
              setFilterBy(newFilterBy)
            }}
          />
        </div>
      </div>
    </Form>
  )
}
